import { render } from "./WebhooksFormTemplate.vue?vue&type=template&id=7905c979"
import script from "./WebhooksFormTemplate.vue?vue&type=script&lang=js"
export * from "./WebhooksFormTemplate.vue?vue&type=script&lang=js"

import "./WebhooksFormTemplate.vue?vue&type=style&index=0&id=7905c979&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__